import React, { Component } from 'react';
import Profilecomponent from '../../common/profilecomponent';
import TutorContainer from './TutorContainer';
import SweetAlert from 'sweetalert2-react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { TabContent, TabPane, Nav, NavLink, NavItem } from "reactstrap";
import classnames from 'classnames';
import Dropzone from '../../common/DropzoneExample';
import TutorCreateContainer from "./TutorCreateContainer";

import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';

import { Link } from "react-router-dom";


const mapStateToProps = (state) => {

	state.TutorReducer.getResponDataTutor	= false;
	state.TutorReducer.errorResponDataTutor = false;
	state.TutorReducer.getTutorDetail		= false;
	state.TutorReducer.errorTutorDetail		= false;
	state.TutorReducer.getResponDataTutorC	= false;
	state.TutorReducer.errorResponDataTutorC= false;
	state.TutorReducer.getTutorBorrar		= false;
	state.TutorReducer.errorTutorBorrar		= false;

	return {
		getResponDataTutor: state.TutorReducer.getResponDataTutor,
		errorResponDataTutor: state.TutorReducer.errorResponDataTutor,
		getTutorDetail: state.TutorReducer.getTutorDetail,
		errorTutorDetail: state.TutorReducer.errorTutorDetail,
		getResponDataTutorC: state.TutorReducer.getResponDataTutorC,
		errorResponDataTutorC: state.TutorReducer.errorResponDataTutorC,
		getTutorBorrar: state.TutorReducer.getTutorBorrar,
		errorTutorBorrar: state.TutorReducer.errorTutorBorrar
	};
};


class Tutor extends Component {

	constructor(props) {
		super(props);
		this.state = {
			activeTab: 1,
			show: false,
		};
	}

	render() {
		const { activeTab } = this.state
		return (
			<>
				<div className="section-body">
					<div className="container-fluid">
						<div className="d-flex justify-content-between align-items-center ">
							<div className="header-action">
								<h1 className="page-title">Tutor</h1>
								<ol className="breadcrumb page-breadcrumb">
									<li className="breadcrumb-item"><a href="#">Escolar</a></li>
									<li className="breadcrumb-item active" aria-current="page">Listar Tutor</li>
								</ol>
							</div>
							<Nav tabs className="page-header-tab">
								
								<NavItem>
									<Link
										to={"/creartutor"}
										className={classnames({ active: activeTab === 3 })}
										onClick={() => this.setState({ activeTab: 3 })}
									>
										Agregar
    			               </Link>
								</NavItem>
							</Nav>

						</div>
					</div>
				</div>

				<div className="section-body mt-4">
					<div className="container-fluid">
						<TabContent activeTab={activeTab}>

							<TabPane tabId={1} className={classnames(['fade show'])}>
								<TutorContainer />
							</TabPane>

						</TabContent>
					</div>
				</div>

			</>
		);

	}//END RENDER


}//END CLASS

export default withRouter(connect(mapStateToProps, null)(Tutor));

